import React from 'react';
import { IncompleteTypes } from '../../../lib/constants';

export default class IncompleteApplicationWarning extends React.Component {
    constructor(props) {
        super(props);

        this.renderMissingFields = this.renderMissingFields.bind(this);
    }

    renderMissingFields(title, values) {
        return <div>
            <label className="bold-text">Missing {title} </label>
            {values.map((field, index) => {
                return <label key={index}> {field}</label>
            })}
        </div>

    }

    render() {
        const { allowIncomplete, fields, viewOnly } = this.props;

        const types = [];
        if ((fields.recipientInfo && fields.recipientInfo.length) || fields.incompleteApplicationDueToRecipient) types.push(IncompleteTypes.Recipient);
        if ((fields.applicationInfo && fields.applicationInfo.length) || (fields.paymentInfo && fields.paymentInfo.length)) types.push(IncompleteTypes.Application);

        return (
            <div className="accent-box-container">
                <div className="accent-box application-warning">
                    {!viewOnly && (allowIncomplete
                        ? <div className="application-warning-header flex-center flex-justify">
                            <div className="application-warning-text">
                                <i className="icon ion-android-warning" />
                                <p>{types.join(" and ")} {types.length > 1 ? "are" : "is"} incomplete
                                {types.indexOf(IncompleteTypes.Application) < 0 && fields.incompleteApplicationDueToRecipient
                                        ? ", and this application is therefore considered incomplete as well.  " : ".  "}
                                    Would you like to save anyways and come back later?</p>
                            </div>
                        </div>
                        : <div className="flex-center application-warning-header">
                            <i className="icon ion-android-warning" />
                            <p>{types.join(" and ")} cannot be updated without the following required fields.</p>
                        </div>)}
                    <div className="accent-box-warnings">
                        {fields.recipientInfo && fields.recipientInfo.length > 0 &&
                            ((viewOnly && fields.incompleteApplicationDueToRecipient)
                                ? "This application is incomplete due to incomplete recipient information."
                                : this.renderMissingFields('Recipient Info', fields.recipientInfo))}
                        {fields.paymentInfo && fields.paymentInfo.length > 0 &&
                            this.renderMissingFields('Payment Info', fields.paymentInfo)}
                        {fields.applicationInfo && fields.applicationInfo.length > 0 &&
                            this.renderMissingFields('Application Info', fields.applicationInfo)}
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/commonComponents/shared/IncompleteApplicationWarning.jsx